{
  "profile_title": "Profile",
  "edit_profile_tab": "Edit profile",
  "password_tab": "Password",
  "company_tab": "Company",
  "payments_tab": "Payments",
  "team_members_tab": "Team members",
  "team_invitations_tab": "Pending invitations",
  "storage_quota_tab": "Storage quota",
  "company_name_label": "Company name",
  "vat_label": "VAT number",
  "line1_label": "Address",
  "line2_label": "Address cont.",
  "city_label": "City",
  "state_label": "State / Province",
  "zipCode_label": "Zip",
  "country_label": "Country",
  "company_submit": "save company information",
  "billing_address": "Billing Address",
  "password_submit": "change password",
  "password_old": "Old password",
  "password_new": "New password",
  "password_confirm": "Confirm new password",
  "title_label": "Title",
  "first_name_label": "First name",
  "name_label": "Name",
  "last_name_label": "Last name",
  "email_label": "Email",
  "phone_label": "Phone",
  "location_label": "Location",
  "time_zone_label": "Time zone",
  "data_usage": "Otakus may use my contact data to keep me informed of products, services and offerings",
  "payment_method": "Payment Method",
  "invoice_history": "Invoice History",
  "added_date": "Added date",
  "role": "Role",
  "invite_creators": "Invite creators",
  "send_invitation": "Send invitation",
  "profile_submit": "Profile submit",
  "success_password": "Password updated",
  "success_company": "Company updated",
  "success_profile": "Profile updated",
  "fieldRequired": "Field is required",
  "e_mail": "E-mail",

  "error_company": "An error has occurred while displaying the company"
}
